import { useMemo } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useAuthRedirect } from '@sandtech-hub-monorepo/ui-auth-kit';
import { useScrollRestoration } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutes } from './routes';
import { generateRoutesFromDefinitionList } from './util';
import { GuardedRoutes } from './guardedRoute';

export const AppRouter = () => {
  useAuthRedirect();
  // Called once here rather than per-page: on mobile, navigating between
  // pages (e.g. from a link scrolled far down) otherwise leaves the new
  // page rendered at whatever scroll offset the previous one was at.
  useScrollRestoration();

  const routeList = useMemo(() => {
    const publicRoutes = generateRoutesFromDefinitionList(AppRoutes.public);
    const privateRoutes = generateRoutesFromDefinitionList(AppRoutes.private);

    return { publicRoutes, privateRoutes };
  }, []);
  return (
    <Routes>
      <Route element={<GuardedRoutes />}>{routeList.privateRoutes}</Route>
      ...{routeList.publicRoutes}
    </Routes>
  );
};
